import { groupBy, map } from 'lodash';
import { DateTime, type DateTimeUnit } from 'luxon';

export const groupByDateTimeUnit = <T, P extends string>(
  items: T[],
  dateSelector: (item: T) => string,
  dateTimeUnit: DateTimeUnit = 'day',
  itemsProp: P = 'items' as P,
) =>
  map(
    groupBy(
      items,
      (item) => DateTime.fromISO(dateSelector(item)).startOf(dateTimeUnit).toISO() ?? '',
    ),
    (items, key) => ({
      day: key,
      [itemsProp]: items,
    }),
  ).sort((a, b) => (!a.day || a.day > b.day ? 1 : -1)) as ({ day: string } & Record<P, T[]>)[];
